module.exports = __webpack_public_path__ + "static/img/r-5.f7d499d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/renovation/r-5.jpg
// module id = 4+c3
// module chunks = 0